import { fetcher } from "utils";
import { IJSendSuccessResponse } from "typings";

export function get__api__v1__userables__products__only_ids(): Promise<IJSendSuccessResponse<{ payload: number[] }>> {
  return fetcher.get("/api/v1/userables/products/only_ids");
}
